module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAKhJREFUWAntlkEOgCAMBMX4I/7/BN6kpyGGZFNSLj2slzUb2ZQBLK33/l4Hzxij/Yef5t3/sArvD0WsM8VXGpHI5pUj5ILUFsA3IUgoNSFFBt+EIKHUhBQZ/NnLot7EgF3N5pVbst0J+zsTUARa9jQQuN4MT/PKnbL5H1pnCgGlEYlsXjlCLkhtAXwTgoRSE1Jk8E0IEkpNSJHBn70s6k0M2NVsXrkl+wCjCCHXCZbYbgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/top_icon_list_card@2x.png
// module id = 902
// module chunks = 127